import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import ExcelReader from 'components/common/FileController/ExcelReader';
import moment from 'moment';
import TrackerSearch from 'components/common/TrackerSearch/TrackerSearch';
import CarriersSelectBox from 'components/common/TrackerSearch/CarriersSelectBox';
import TransDetailModal from './TransDetailModal';
import { ConfigProvider, Table, Pagination, Button, Popconfirm, Select, Radio, DatePicker, Modal, notification, Input, Spin, Tag } from 'antd';
import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
import jquery from 'jquery';
import $ from 'jquery';   

moment.locale('ko');

@inject("transStore")

@observer
class TransList extends Component {
  state = {
    // 상세보기 모달
    modalOpen: false,
    selectData: null,

    // 배송조회 모달
    modalOpenTracker: false,
    orTracker: '',
    orInvoiceNo: '',
    orInvoiceNoEtc: '',

    // 상태변경 모달
    modalVisible: false,
    changStat: "",
    
    // 반려사유 입력
    rejectReason: '',

    selectedRowKeys: [],
    selectedRows: [],

    // 유빈 - 주문취소
    detailData: [],
    editingKey: null,
    editData: {},
  };

  // 유빈 - 주문취소
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.detailData !== this.props.detailData) {
      this.setState({ detailData: nextProps.detailData, editingKey: null, editData: {} });
    }
  }

  UNSAFE_componentWillMount() {
    if(this.props.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) {
        this.props.transStore.onChangValue('orStat', '2'); // 주문완료
    } else {
        this.props.transStore.onChangValue('orStat', '1'); // 승인대기
      
    }
    this.props.transStore.disOrderList(1);
    this.props.transStore.disOrderCnt();
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.transStore.disOrderList(pageIdx);
  };

  onSearch = () => {
    this.props.transStore.disOrderCnt();
    this.props.transStore.disOrderList(1);
  };
  
  onChange = (e) => {
    this.setState({ selectedRowKeys: [], selectedRows: [] });
    this.props.transStore.onChangValue('orStat', e.target.value);
    this.props.transStore.disOrderList(1);
  };

  render() {
    const { ceType, cGbn } = this.props; 
    const {
      valCondition,
      onChangValue,
      orderCnt,
      orderList,
      pageInfo,
      delKcpOrderInfo,
      
      disOrderList,
      disOrderDetail,
      modOrderInfo,
      modOrderTracker,
      excelUploadIng,
      onExcelUploadIng
    } = this.props.transStore;
    const {
      changStat,
      
      modalOpen, 
      selectData,

      modalOpenTracker,
      orTracker,
      orInvoiceNo,
      orInvoiceNoEtc,

      modalVisible,
      rejectReason,

      selectedRowKeys,
      selectedRows,

      
    } = this.state;

    // 유빈 - 로지텍일때
    const columnsLG2 = [
      { title: 'No', dataIndex: 'RNUM', width: '5%', align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: '10%', align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: '13%', align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },

      // 유빈
      { title : '결제수단', dataIndex : 'paymentNm', width : '10%', align : 'center' },

      { title: '주문상태', dataIndex: 'orStat', key: 'orStat', width: '18%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item === "1" || item === "2") && <Fragment>주문완료</Fragment>}
            {(item === "4") && // 배송준비
              (ceType === process.env.REACT_APP_TYPE_YUJIN ? 
                <Button
                  onClick={()=>this.setState({ 
                    modalVisible: true, 
                    selectData: record, 
                    orTracker: "", 
                    orInvoiceNo: "",
                    orInvoiceNoEtc: "",
                    changStat: "5"
                  })}
                >배송정보입력</Button>
              : <Fragment>배송준비</Fragment>)
            }
            {item === "5" && // 배송중
              <Fragment>
                {/* <a href={`https://tracker.delivery/#/${record.orTracker}/${record.orInvoiceNo}`} target="blank" /> */}
                <Button
                  style={{ marginRight: 8 }}
                  onClick={()=>{
                    this.setState({ 
                      modalOpenTracker: true,
                      orTracker: record.orTracker,
                      orInvoiceNo: record.orInvoiceNo,
                      orInvoiceNoEtc: record.orInvoiceNoEtc
                    });
                  }}
                >배송조회</Button>
                <Button
                  type="primary"
                  onClick={()=>this.setState({ modalVisible: true, selectData: record, changStat: "6" })}
                >수취확인</Button>
              </Fragment>
            }
          </Fragment>
        )}
      },
      { title: '센터', dataIndex: 'ceNm', width: '9%', align: 'center'},
      { title: '총 건수', dataIndex: 'totalCnt', width: '7%', align: 'center' },
      { title: '총 주문액', dataIndex: 'totalPrice', width: '9%', key: 'gdPrice', align: 'center',
        render: (item, record) => { return(
          item !== undefined && item !== null && item !== '' &&
            item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )}
      },
      /* 2026-03-03 한중민과장 요청 유진매니저만 취소가능하도록
      // 유빈 - 주문취소
      { title : '주문취소', dataIndex : 'orCartNo', width : '9%', align : 'center',  
      render: (item, record, index) => {
        window.addEventListener('message', function(e) {    
          if(e.data.childData === 'please reload'){
            this.window.location.reload();
          }
        });

        const kcpClick = () =>{
         // console.log(record);
          //onsole.log(index);
          // let deliFee=0;
          // if(record.totalCnt < 11){
          //   deliFee = 3600;
          // }

          if(record.tno !== undefined && record.tno !== null && record.tno !== '' ){
            window.open("", "_cancel", "toolbar=no,scrollbars=no,resizable=yes,top=500,left=500,width=660,height=470");

            var newForm = document.createElement('form');
            newForm.name = 'newForm';
            newForm.method = 'post';
            // newForm.action = 'http://localhost:80/?order/cancel';
            // newForm.action = 'http://www.yujinmalls.co.kr/order/cancel';
            newForm.action = `${process.env.REACT_APP_URL}/order/cancel`;
            newForm.target = '_cancel';
      
            // // 주문번호
            var input1 = document.createElement('input');
            input1.setAttribute("type", "hidden");
            input1.setAttribute("name", "or_cart_no");
            input1.setAttribute("value", record.orCartNo);
            newForm.appendChild(input1); 

            // // 전자결재채번
            var input2 = document.createElement('input');
            input2.setAttribute("type", "hidden");
            input2.setAttribute("name", "tno");
            input2.setAttribute("value", record.tno);
            newForm.appendChild(input2);           
            // append input (to form)

            var input3 = document.createElement('input');
            input3.setAttribute("type", "hidden");
            input3.setAttribute("name", "or_deliver_fee");
            input3.setAttribute("value", record.orDeliverPrice);
            newForm.appendChild(input3);           
            // append input (to form)            

            var input4 = document.createElement('input');
            input4.setAttribute("type", "hidden");
            input4.setAttribute("name", "or_card_no");
            input4.setAttribute("value", record.orCardNo);
            newForm.appendChild(input4);           
            // append input (to form)     

            var input5 = document.createElement('input');
            input5.setAttribute("type", "hidden");
            input5.setAttribute("name", "or_type");
            input5.setAttribute("value", 'cancel');
            newForm.appendChild(input5);    
            // append form (to body)
            document.body.appendChild(newForm);    

            // submit form
            newForm.submit();
            $("#newForm").remove();          
          }else{
            delKcpOrderInfo(record)
          }
        }
        return (
          <Fragment>
          <Popconfirm
                // 주문취소(로지텍 - 매니저X)
                disabled = {record.orStat === '0' || record.orStat === '4' || record.orStat === '5' || record.orPayment === '100000000000'}
                title="주문을 취소하시겠습니까?"
                onConfirm={()=> kcpClick(record)}
                //onConfirm={()=>delKcpOrderInfo(record)}
                // 부모 엘리먼트에게 이벤트 전달을 중단해야 할 때 쓰이는 함수
                onClick={(e)=>e.stopPropagation()}
              >
          <Button
            disabled = {record.orStat === '0' || record.orStat === '4' || record.orStat === '5' || record.orPayment === '100000000000'}
          >주문취소</Button>
          </Popconfirm>
          </Fragment>
      )}
      
    },*/
      { title: '주문상세보기', dataIndex: '', key: '', width: '7%', align: 'center',
        render: (item, record) => { return(
          <Button
            onClick={()=>{
              disOrderDetail(record);
              this.setState({ modalOpen: true, selectData: record });
            }}
          >상세보기</Button>
        )}
      },
    ];

    // 로지텍 - 매니저 일 때
    const columnsLG = [
      { title: 'No', dataIndex: 'RNUM', width: '3%', align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: '10%', align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      // 주문번호 눌렀을 때 색깔 변하게 만들기.
      { title: '주문번호', dataIndex: 'orCartNo', width: '13%', align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },

      // 유빈
      { title : '결제수단', dataIndex : 'paymentNm', width : '8%', align : 'center' },

      { title: '주문상태', dataIndex: 'orStat', key: 'orStat', width: '8%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item === "0") && <Fragment>주문취소</Fragment>}
            {(item === "1" || item === "2") && <Fragment>주문완료</Fragment>}
            {(item === "4") && // 배송준비
              (ceType === process.env.REACT_APP_TYPE_YUJIN ? 
                <Button
                  onClick={()=>this.setState({ 
                    modalVisible: true, 
                    selectData: record, 
                    orTracker: "", 
                    orInvoiceNo: "",
                    orInvoiceNoEtc: "",
                    changStat: "5"
                  })}
                >배송정보입력</Button>
              : <Fragment>배송준비</Fragment>)
            }
            {item === "5" && // 배송중
              <Fragment>
                {/* <a href={`https://tracker.delivery/#/${record.orTracker}/${record.orInvoiceNo}`} target="blank" /> */}
                <Button
                  style={{ marginRight: 8 }}
                  onClick={()=>{
                    this.setState({ 
                      modalOpenTracker: true,
                      orTracker: record.orTracker,
                      orInvoiceNo: record.orInvoiceNo,
                      orInvoiceNoEtc: record.orInvoiceNoEtc
                    });
                  }}
                >배송조회</Button>
                <Button
                  type="primary"
                  onClick={()=>this.setState({ modalVisible: true, selectData: record, changStat: "6" })}
                >수취확인</Button>
              </Fragment>
            }
          </Fragment>
        )}
      },
      { title: '지사', dataIndex: 'orBranchNm', width: '10%', align: 'center' },
      { title: '센터', dataIndex: 'ceNm', width: '10%', align: 'center'},
      { title: '총 건수', dataIndex: 'totalCnt', width: '8%', align: 'center' },
      { title: '총 주문액', dataIndex: 'totalPrice', width: '9%', key: 'gdPrice', align: 'center',
        render: (item, record) => { return(
          item !== undefined && item !== null && item !== '' &&
            item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )}
      },

      // 유빈 - 주문취소
      { title : '주문취소', dataIndex : 'orCartNo', width : '7%', align : 'center',  
      render: (item, record, index) => {
        window.addEventListener('message', function(e) {    
          if(e.data.childData === 'please reload'){
            this.window.location.reload();
          }
        });

        const kcpClick = () =>{
         // console.log(record);
          //onsole.log(index);
          // let deliFee=0;
          // if(record.totalCnt < 11){
          //   deliFee = 3600;
          // }

          if(record.tno !== undefined && record.tno !== null && record.tno !== '' ){
            window.open("", "_cancel", "toolbar=no,scrollbars=no,resizable=yes,top=500,left=500,width=660,height=470");

            var newForm = document.createElement('form');
            newForm.name = 'newForm';
            newForm.method = 'post';
            // newForm.action = 'http://localhost:80/?order/cancel';
            // newForm.action = 'http://www.yujinmalls.co.kr/order/cancel';
            newForm.action = `${process.env.REACT_APP_URL}/order/cancel`;
            newForm.target = '_cancel';
      
            // // 주문번호
            var input1 = document.createElement('input');
            input1.setAttribute("type", "hidden");
            input1.setAttribute("name", "or_cart_no");
            input1.setAttribute("value", record.orCartNo);
            newForm.appendChild(input1); 

            // // 전자결재채번
            var input2 = document.createElement('input');
            input2.setAttribute("type", "hidden");
            input2.setAttribute("name", "tno");
            input2.setAttribute("value", record.tno);
            newForm.appendChild(input2);           
            // append input (to form)

            var input3 = document.createElement('input');
            input3.setAttribute("type", "hidden");
            input3.setAttribute("name", "or_deliver_fee");
            input3.setAttribute("value", record.orDeliverPrice);
            newForm.appendChild(input3);           
            // append input (to form)            

            var input4 = document.createElement('input');
            input4.setAttribute("type", "hidden");
            input4.setAttribute("name", "or_card_no");
            input4.setAttribute("value", record.orCardNo);
            newForm.appendChild(input4);           
            // append input (to form)     

            var input5 = document.createElement('input');
            input5.setAttribute("type", "hidden");
            input5.setAttribute("name", "or_type");
            input5.setAttribute("value", 'cancel');
            newForm.appendChild(input5);    
            // append form (to body)
            document.body.appendChild(newForm);    

            // submit form
            newForm.submit();
            $("#newForm").remove();          
          }else{
            delKcpOrderInfo(record)
          }
        }
        return (
          <Fragment>
          <Popconfirm
                // 주문취소 (매니저)
                disabled = {record.orStat === '0'}
                title="주문을 취소하시겠습니까?"
                onConfirm={()=> kcpClick(record)}
                //onConfirm={()=>delKcpOrderInfo(record)}
                // 부모 엘리먼트에게 이벤트 전달을 중단해야 할 때 쓰이는 함수
                onClick={(e)=>e.stopPropagation()}
              >
          <Button
            disabled = {record.orStat === '0'}
          >주문취소</Button>
          </Popconfirm>
          </Fragment>
      )}
      
    },
//LHS 추가
      { title: '입금상태', dataIndex: 'vaccountYn', key: 'vaccountYn' , width: '10%', align: 'center',
        render: (item, record) => { 
          return(
            <Fragment>
              {(item ===   "Y") ? <Fragment>입금완료</Fragment> : <Fragment></Fragment> }
            </Fragment>
            
        )}
      },

      { title: '주문상세보기', dataIndex: '', key: '', width: '7%', align: 'center',
        render: (item, record) => { return(
          <Button
            onClick={()=>{
              disOrderDetail(record);
              this.setState({ modalOpen: true, selectData: record });
            }}
          >상세보기</Button>
        )}
      },
    ];

    // 로지텍이 아닐 때
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '5%', align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: '10%', align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: '10%', align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },
      { title: '주문상태', dataIndex: 'orStat', key: 'orStat', width: '18%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item === "1") && // 승인대기
              ((ceType === process.env.REACT_APP_TYPE_CENTER || ceType === process.env.REACT_APP_TYPE_YUJIN) ? <Fragment>승인대기</Fragment>
              : <Fragment>
                  <Button
                    style={{ marginRight: 8 }}
                    onClick={()=>this.setState({ modalVisible: true, selectData: [record], changStat: "2" })}
                  >승인</Button>
                  <Button
                    onClick={()=>this.setState({ modalVisible: true, selectData: record, rejectReason: "", changStat: "3" })}
                  >승인반려</Button>
                </Fragment>)
            }
            {(item === "2") && // 승인완료
              (ceType === process.env.REACT_APP_TYPE_YUJIN ? 
                  <Button
                    onClick={()=>this.setState({ modalVisible: true, selectData: [record], changStat: "4" })}
                  >배송준비</Button>
                : <Fragment>승인완료</Fragment>)
            }
                
            {(item === "4") && // 배송준비
              (ceType === process.env.REACT_APP_TYPE_YUJIN ? 
                <Button
                  onClick={()=>this.setState({ 
                    modalVisible: true, 
                    selectData: record, 
                    orTracker: "", 
                    orInvoiceNo: "",
                    orInvoiceNoEtc: "",
                    changStat: "5"
                  })}
                >배송정보입력</Button>
              : <Fragment>배송준비</Fragment>)
            }
            {item === "5" && // 배송중
              <Fragment>
                {/* <a href={`https://tracker.delivery/#/${record.orTracker}/${record.orInvoiceNo}`} target="blank" /> */}
                <Button
                  style={{ marginRight: 8 }}
                  onClick={()=>{
                    this.setState({ 
                      modalOpenTracker: true,
                      orTracker: record.orTracker,
                      orInvoiceNo: record.orInvoiceNo,
                      orInvoiceNoEtc: record.orInvoiceNoEtc
                    });
                  }}
                >배송조회</Button>
                <Button
                  type="primary"
                  onClick={()=>this.setState({ modalVisible: true, selectData: record, changStat: "6" })}
                >수취확인</Button>
              </Fragment>
            }
          </Fragment>
        )}
      },
      { title: '지사', dataIndex: 'orBranchNm', width: '8%', align: 'center' },
      { title: '센터코드', dataIndex: 'orCeCd', width: '9%', align: 'center' },
      { title: '센터', dataIndex: 'ceNm', width: '8%', align: 'center' },
      { title: '총 건수', dataIndex: 'totalCnt', width: '8%', align: 'center' },
      { title: '총 주문액', dataIndex: 'totalPrice', width: '9%', key: 'gdPrice', align: 'center',
        render: (item, record) => { return(
          item !== undefined && item !== null && item !== '' &&
            item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )}
      },
      { title: '주문상세보기', dataIndex: '', key: '', width: '8%', align: 'center',
        render: (item, record) => { return(
          <Button
            onClick={()=>{
              disOrderDetail(record);
              this.setState({ modalOpen: true, selectData: record });
            }}
          >상세보기</Button>
        )}
      },
    ];

    const rowSelection = {
      columnWidth: '2%',
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({selectedRowKeys, selectedRows});
      }
    };
    return (
      <Spin
        tip="엑셀 업로드 중..." 
        spinning={excelUploadIng}
        size="large"
      >
        <div className="srch_order_status">
          <Radio.Group
            size="large"
            onChange={this.onChange}
            value={valCondition.orStat}
          >
            {(cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG)
            ? 
              <Fragment>
              <p className='chkClick'>아래 버튼을 클릭하시면 진행상황을 확인할 수 있습니다.</p>
              <Radio.Button value="2">주문완료<b>
                {(orderCnt !== null) 
                ? (orderCnt.orStat1 + orderCnt.orStat2) : 0 } </b><span className="txt_hide">건</span>
              </Radio.Button>
              <Radio.Button value="0">주문취소<b>
                {(orderCnt !== null) 
                ? (orderCnt.orStat0 ) : 0 } </b><span className="txt_hide">건</span>
              </Radio.Button>              
              </Fragment>
            : <Fragment>
                <Radio.Button value="1">승인대기<b>
                  {(orderCnt !== null && orderCnt.orStat1 !== undefined && orderCnt.orStat1 !== null) 
                  ? orderCnt.orStat1 : 0 } </b><span className="txt_hide">건</span>
                </Radio.Button>
                <Radio.Button value="2">승인완료<b>
                  {(orderCnt !== null && orderCnt.orStat2 !== undefined && orderCnt.orStat2 !== null)
                  ? orderCnt.orStat2 : 0 } </b><span className="txt_hide">건</span>
                </Radio.Button>
              </Fragment>

            }
            
            <Radio.Button value="4">배송준비<b>
              {(orderCnt !== null && orderCnt.orStat4 !== undefined && orderCnt.orStat4 !== null)
              ? orderCnt.orStat4 : 0 } </b><span className="txt_hide">건</span>
            </Radio.Button>
            <Radio.Button value="5">배송중<b>
              {(orderCnt !== null && orderCnt.orStat5 !== undefined && orderCnt.orStat5 !== null)
              ? orderCnt.orStat5 : 0 } </b><span className="txt_hide">건</span>
            </Radio.Button>
          </Radio.Group>
        </div>
        
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">주문기간</span>
              <ConfigProvider locale={koKr}>
                <DatePicker.RangePicker
                  style={{ width: 270, marginRight: '20px' }}
                  format={'YYYY-MM-DD'}
                  allowClear={false}
                  defaultValue={[
                    moment(moment().subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                    moment(moment().format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                  ]}
                  onChange={(date)=>{
                    onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                    onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>

        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disOrderList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          {(valCondition.orStat === '5') && // 배송중
            <h4 style={{ color: 'red' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            </h4>
          }
          <div className="button-right">
            <ul>
            {(valCondition.orStat === '1' && // 승인대기
              (ceType === process.env.REACT_APP_TYPE_MASTER || ceType === process.env.REACT_APP_TYPE_BRANCH)) &&
              <li>
                <Button
                  type="primary"
                  onClick={()=>{
                    if (selectedRows.length <= 0) {
                      notification.warning({placement: 'bottomLeft', message: `주문을 선택해주세요.`, duration: 2});
                    } else {
                      this.setState({ modalVisible: true, selectData: selectedRows, changStat: "2" });
                    }
                  }}
                >선택주문 전체승인</Button>
              </li>
            }
            {(valCondition.orStat === '2' && // 승인완료
              (ceType === process.env.REACT_APP_TYPE_YUJIN)) &&
              <Fragment>
              <li>
                <Button
                  type="primary"
                  onClick={()=>{
                    if (selectedRows.length <= 0) {
                      notification.warning({placement: 'bottomLeft', message: `주문을 선택해주세요.`, duration: 2});
                    } else {
                      this.setState({ modalVisible: true, selectData: selectedRows, changStat: "4" });
                    }
                  }}
                >선택주문 배송준비</Button>
              </li>
              <li>
                {/* 납품내역 다운 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-DELIVERY-LIST'}
                  schInfo={valCondition}
                />
              </li>
              <li>
                {/* 세부내역 다운 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-READY-LIST'}
                  schInfo={valCondition}
                />
              </li>
              </Fragment>
            }
            {(valCondition.orStat === '4' && // 배송준비
            (ceType === process.env.REACT_APP_TYPE_YUJIN)) &&
            <Fragment>
              <li>
                {/* 운송장번호 엑셀업로드 */}
                <ExcelReader
                  actionType={'upload'}
                  actionText={'운송장번호'}
                  excelUpload={(data)=>modOrderTracker(data)}
                  onExcelUploadIng={(boolen)=>onExcelUploadIng(boolen)}
                />
              </li>
            </Fragment>
            }
            {(valCondition.orStat === '5' && // 배송중
              (ceType === process.env.REACT_APP_TYPE_YUJIN)) &&
              <li>
                <Button
                  type="primary"
                  onClick={()=>{
                    if (selectedRows.length <= 0) {
                      notification.warning({placement: 'bottomLeft', message: `주문을 선택해주세요.`, duration: 2});
                    } else {
                      this.setState({ modalVisible: true, selectData: selectedRows, changStat: "10" });
                    }
                  }}
                >선택주문 배송준비</Button>
              </li>
            }
            </ul>
          </div>
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          columns={
            (cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG && 
              ceType === process.env.REACT_APP_TYPE_YUJIN) ? columnsLG : 
            (cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) ? columnsLG2 : columns
           //(cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) ? columnsLG : columns
          } 
          dataSource={orderList}
          pagination={false}
          rowSelection={
            ( (valCondition.orStat === '1' && (ceType === process.env.REACT_APP_TYPE_MASTER || ceType === process.env.REACT_APP_TYPE_BRANCH)) 
            || (valCondition.orStat === '2' && (ceType === process.env.REACT_APP_TYPE_YUJIN))
            || (valCondition.orStat === '5' && (ceType === process.env.REACT_APP_TYPE_YUJIN)) 
            )
            ? rowSelection : null
          }
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>

        {/* 상세보기 모달 */}
        <TransDetailModal
          crudYn={true}
          ceType={ceType}
          cGbn={cGbn}
          modalOpen={modalOpen}
          modalClose={()=>this.setState({ modalOpen: false })}
          selectData={selectData}
        />

        {/* 배송조회 모달 */}
        <TrackerSearch
          modalOpen={modalOpenTracker}
          modalClose={()=>this.setState({ modalOpenTracker: false})}
          tracker={orTracker}
          invoiceNo={orInvoiceNo}
          orInvoiceNoEtc={orInvoiceNoEtc}
        />

        {/* 상태변경 모달 */}
        <Modal
          width={(changStat === "2" || changStat === "4" || changStat === "10") ? 1000 : 600}
          title={ (changStat === "2") ? "승인하기"
                : (changStat === "3") ? "반려하기"
                : (changStat === "4") ? "배송준비"
                : (changStat === "5") ? "배송정보"
                : (changStat === "6") ? "구매확정" 
                : ""
          }
          cancelText={"취소"}
          okText={"확인"}
          closable={false}
          visible={modalVisible}
          onCancel={()=>this.setState({ modalVisible: false })}
          onOk={()=>{
            if (selectData === null) {
              notification.warning({placement: 'bottomLeft', message: `선택정보가 없습니다.`, duration: 2});
              this.setState({ modalVisible: false });
              return;
            }

            if (changStat === "2") {
              // if (rejectReason === "") {
              //   notification.warning({placement: 'bottomLeft', message: `사유를 입력해주세요.`, duration: 2});
              //   return;
              // }
              let sendData = [];
              selectData.map((item)=>{
                return(sendData.push({...item, rejectReason: rejectReason, orStat: changStat }))
              });
              modOrderInfo(sendData);
            } else if (changStat === "4") {
              let sendData = [];
              selectData.map((item)=>{
                return(sendData.push({...item, orStat: changStat }))
              });
              modOrderInfo(sendData);
            } else if (changStat === "3") {
              if (rejectReason === "") {
                notification.warning({placement: 'bottomLeft', message: `사유를 입력해주세요.`, duration: 2});
                return;
              }
              modOrderInfo([{...selectData, rejectReason: rejectReason, orStat: changStat}]);
            } else if (changStat === "5") {
              // if (orTracker === '' || orInvoiceNo === '') {
              //   notification.warning({placement: 'bottomLeft', message: `택배사/운송장번호를 확인하세요.`, duration: 2});
              //   return;
              // }
              modOrderInfo([{...selectData, orTracker: orTracker, orInvoiceNo: orInvoiceNo, orInvoiceNoEtc: orInvoiceNoEtc, orStat: changStat}]);
            } else if (changStat === "10") {  // 배송중->배송준비로경
              let sendData = [];
              selectData.map((item)=>{
                return(sendData.push({...item, orStat: "4" }))
              });
              modOrderInfo(sendData);
            } else {
              modOrderInfo([{...selectData, orStat: changStat}]);
            }
            
            this.setState({ modalVisible: false, selectedRowKeys: [], selectedRows: [] });
          }}
        >
          {selectData !== null && (changStat === "2" || changStat === "4" || changStat === "10") && // "승인하기" // "배송준비" // "배송중=>배송준비"
            <Fragment>
              <p className="board_total">총 {selectData.length}건</p>
              <Table 
                style={{ width:'100%'}}
                scroll={{ y: 300}}
                rowKey={(record)=>record.RNUM}
                columns={[
                  { title: '주문일', dataIndex: 'orDate', width: '15%', align: 'center',
                    render: (item, record) => { return(
                      moment(item).format('YYYY-MM-DD')
                    )}
                  },
                  { title: '지사', dataIndex: 'orBranchNm', width: '15%', align: 'center' },
                  { title: '센터', dataIndex: 'ceNm', width: '15%', align: 'center' },
                  { title: '주문번호', dataIndex: 'orCartNo',  width: '25%', align: 'reft',
                    render: (item, record) => { return(
                      <Fragment>
                        <span style={{ marginRight: 5 }}>{item}</span>
                        {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
                        && <Tag color="blue">기준외주문</Tag>}
                      </Fragment>
                    )}
                  },
                  { title: '총 건수', dataIndex: 'totalCnt',  width: '15%', align: 'center' },
                  { title: '총 주문액', dataIndex: 'totalPrice',  width: '15%', align: 'center',
                    render: (item, record) => { return(
                      item !== undefined && item !== null && item !== '' &&
                        item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    )}
                  },
                ]} 
                dataSource={selectData}
                pagination={false}
              />
              <br />
              {/* {changStat === "2" && 
              <table className="table_st_wrap">
                <tbody>
                  <tr>
                    <th>승인사유</th>
                    <td>
                      <Input 
                        placeholder="사유를 입력하세요"
                        value={rejectReason}
                        onChange={(e)=>this.setState({rejectReason: e.target.value})}
                        style={{ width: '100%' }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              } */}
              <div className="last_chk_text">
              {changStat === "2" && <b>구매를 승인하시겠습니까?</b>}
              {changStat === "4" && <b>구매를 배송을 준비하시겠습니까?</b>}
              {changStat === "10" && <b>배송중인 상품을 배송준비중으로 변경하시겠습니까?</b>}
              </div>
            </Fragment>
          }

          {selectData !== null && changStat === "3" && // "반려하기"
            <Fragment>
              <table className="table_st_wrap">
                <tbody>
                  <tr><th>지사</th><td>{selectData.orBranchNm}</td></tr>
                  <tr><th>센터</th><td>{selectData.ceNm}</td></tr>
                  <tr><th>총 건수</th><td>{selectData.totalCnt}</td></tr>
                  <tr>
                    <th>총 주문액</th>
                    <td>
                      {selectData.totalPrice !== undefined && selectData.totalPrice !== null &&
                      selectData.totalPrice !== "" && selectData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </td>
                  </tr>
                  <tr>
                    <th>반려사유</th>
                    <td>
                      <Input 
                        placeholder="사유를 입력하세요"
                        value={rejectReason}
                        onChange={(e)=>this.setState({rejectReason: e.target.value})}
                        style={{ width: '100%' }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="last_chk_text">
                <b>승인반려 하시겠습니까?</b>
              </div>
            </Fragment>
          }

          {selectData !== null && changStat === "5" && // "배송정보"
            <Fragment>
            <table className="table_st_wrap">
              <tbody>
                <tr><th>지사</th><td>{selectData.orBranchNm}</td></tr>
                <tr><th>센터</th><td>{selectData.ceNm}</td></tr>
                <tr><th>총 건수</th><td>{selectData.totalCnt}</td></tr>
                <tr>
                  <th>총 주문액</th>
                  <td>
                    {selectData.totalPrice !== undefined && selectData.totalPrice !== null &&
                    selectData.totalPrice !== "" && selectData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                </tr>
                <tr>
                  <th>택배사</th>
                  <td>
                    <CarriersSelectBox
                      setTracker={(data)=>this.setState({orTracker: data})}
                      propsDisabled={false}
                      tracker={orTracker}
                    />
                  </td>
                </tr>
                <tr>
                  <th>운송장번호</th>
                  <td>
                    <Input 
                      placeholder="운송장번호를 입력하세요."
                      value={orInvoiceNo}
                      onChange={(e)=>this.setState({orInvoiceNo: e.target.value})}
                      style={{ width: '100%' }}
                    />
                  </td>
                </tr>
                {/* <tr>
                  <th>운송장번호(추가)</th>
                  <td>
                    <Input 
                      placeholder="운송장번호(추가)를 입력하세요."
                      value={orInvoiceNoEtc}
                      onChange={(e)=>this.setState({orInvoiceNoEtc: e.target.value})}
                      style={{ width: '100%' }}
                    />
                  </td>
                </tr> */}
              </tbody>
            </table>
            <div className="last_chk_text">
              <b>구매를 배송 하시겠습니까?</b>
            </div>
            </Fragment>
          }

          {selectData !== null && changStat === "6" && // "구매확정"
            <Fragment>
              <table className="table_st_wrap">
                <tbody>
                  <tr><th>지사</th><td>{selectData.orBranchNm}</td></tr>
                  <tr><th>센터</th><td>{selectData.ceNm}</td></tr>
                  <tr><th>총 건수</th><td>{selectData.totalCnt}</td></tr>
                  <tr>
                    <th>총 주문액</th>
                    <td>
                      {selectData.totalPrice !== undefined && selectData.totalPrice !== null &&
                      selectData.totalPrice !== "" && selectData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="last_chk_text">
                <b>구매에 대한 배송수취를 확인하시겠습니까?</b>
              </div>
            </Fragment>
          }
        </Modal>

      </Spin>
    );
  }

}

export default withRouter(TransList);